[
  {
    "code": "LK-52-001",
    "name": "Addalachchenai"
  },
  {
    "code": "LK-13-001",
    "name": "Agalawatta"
  },
  {
    "code": "LK-52-002",
    "name": "Akkaraipattu"
  },
  {
    "code": "LK-31-001",
    "name": "Akmeemana"
  },
  {
    "code": "LK-21-001",
    "name": "Akurana"
  },
  {
    "code": "LK-32-001",
    "name": "Akuressa"
  },
  {
    "code": "LK-61-001",
    "name": "Alawwa"
  },
  {
    "code": "LK-52-003",
    "name": "Alayadiwembu"
  },
  {
    "code": "LK-23-001",
    "name": "Ambagamuwa"
  },
  {
    "code": "LK-31-002",
    "name": "Ambalangoda"
  },
  {
    "code": "LK-33-001",
    "name": "Ambalantota"
  },
  {
    "code": "LK-22-001",
    "name": "Ambanganga Korale"
  },
  {
    "code": "LK-61-002",
    "name": "Ambanpola"
  },
  {
    "code": "LK-52-004",
    "name": "Ampara"
  },
  {
    "code": "LK-62-001",
    "name": "Anamaduwa"
  },
  {
    "code": "LK-33-002",
    "name": "Angunakolapelessa"
  },
  {
    "code": "LK-62-002",
    "name": "Arachchikattuwa"
  },
  {
    "code": "LK-92-001",
    "name": "Aranayaka"
  },
  {
    "code": "LK-32-002",
    "name": "Athuraliya"
  },
  {
    "code": "LK-12-001",
    "name": "Attanagalla"
  },
  {
    "code": "LK-91-001",
    "name": "Ayagama"
  },
  {
    "code": "LK-82-001",
    "name": "Badalkumbura"
  },
  {
    "code": "LK-31-003",
    "name": "Baddegama"
  },
  {
    "code": "LK-81-001",
    "name": "Badulla"
  },
  {
    "code": "LK-91-002",
    "name": "Balangoda"
  },
  {
    "code": "LK-31-004",
    "name": "Balapitiya"
  },
  {
    "code": "LK-61-003",
    "name": "Bamunakotuwa"
  },
  {
    "code": "LK-13-002",
    "name": "Bandaragama"
  },
  {
    "code": "LK-81-002",
    "name": "Bandarawela"
  },
  {
    "code": "LK-33-003",
    "name": "Beliatta"
  },
  {
    "code": "LK-31-005",
    "name": "Bentota"
  },
  {
    "code": "LK-13-003",
    "name": "Beruwala"
  },
  {
    "code": "LK-82-002",
    "name": "Bibile"
  },
  {
    "code": "LK-61-004",
    "name": "Bingiriya"
  },
  {
    "code": "LK-12-002",
    "name": "Biyagama"
  },
  {
    "code": "LK-31-006",
    "name": "Bope-Poddala"
  },
  {
    "code": "LK-92-002",
    "name": "Bulathkohupitiya"
  },
  {
    "code": "LK-13-004",
    "name": "Bulathsinhala"
  },
  {
    "code": "LK-82-003",
    "name": "Buttala"
  },
  {
    "code": "LK-62-003",
    "name": "Chilaw"
  },
  {
    "code": "LK-11-001",
    "name": "Colombo"
  },
  {
    "code": "LK-52-005",
    "name": "Damana"
  },
  {
    "code": "LK-22-002",
    "name": "Dambulla"
  },
  {
    "code": "LK-62-004",
    "name": "Dankotuwa"
  },
  {
    "code": "LK-52-006",
    "name": "Dehiattakandiya"
  },
  {
    "code": "LK-92-003",
    "name": "Dehiovita"
  },
  {
    "code": "LK-11-002",
    "name": "Dehiwala-Mount Lavinia"
  },
  {
    "code": "LK-41-001",
    "name": "Delft"
  },
  {
    "code": "LK-21-002",
    "name": "Delthota"
  },
  {
    "code": "LK-92-004",
    "name": "Deraniyagala"
  },
  {
    "code": "LK-32-003",
    "name": "Devinuwara"
  },
  {
    "code": "LK-32-004",
    "name": "Dickwella"
  },
  {
    "code": "LK-72-001",
    "name": "Dimbulagala"
  },
  {
    "code": "LK-12-003",
    "name": "Divulapitiya"
  },
  {
    "code": "LK-13-005",
    "name": "Dodangoda"
  },
  {
    "code": "LK-21-003",
    "name": "Doluwa"
  },
  {
    "code": "LK-12-004",
    "name": "Dompe"
  },
  {
    "code": "LK-91-003",
    "name": "Eheliyagoda"
  },
  {
    "code": "LK-61-005",
    "name": "Ehetuwewa"
  },
  {
    "code": "LK-72-002",
    "name": "Elahera"
  },
  {
    "code": "LK-91-004",
    "name": "Elapatha"
  },
  {
    "code": "LK-81-003",
    "name": "Ella"
  },
  {
    "code": "LK-31-007",
    "name": "Elpitiya"
  },
  {
    "code": "LK-91-005",
    "name": "Embilipitiya"
  },
  {
    "code": "LK-52-007",
    "name": "Eragama"
  },
  {
    "code": "LK-51-001",
    "name": "Eravur Pattu"
  },
  {
    "code": "LK-51-002",
    "name": "Eravur Town"
  },
  {
    "code": "LK-71-001",
    "name": "Galenbindunuwewa"
  },
  {
    "code": "LK-22-003",
    "name": "Galewela"
  },
  {
    "code": "LK-61-006",
    "name": "Galgamuwa"
  },
  {
    "code": "LK-92-005",
    "name": "Galigamuwa"
  },
  {
    "code": "LK-31-008",
    "name": "Galle Four Gravets"
  },
  {
    "code": "LK-71-002",
    "name": "Galnewa"
  },
  {
    "code": "LK-12-005",
    "name": "Gampaha"
  },
  {
    "code": "LK-61-007",
    "name": "Ganewatta"
  },
  {
    "code": "LK-21-004",
    "name": "Ganga Ihala Korale"
  },
  {
    "code": "LK-61-008",
    "name": "Giribawa"
  },
  {
    "code": "LK-91-006",
    "name": "Godakawela"
  },
  {
    "code": "LK-53-001",
    "name": "Gomarankadawala"
  },
  {
    "code": "LK-31-009",
    "name": "Habaraduwa"
  },
  {
    "code": "LK-32-005",
    "name": "Hakmana"
  },
  {
    "code": "LK-81-004",
    "name": "Hali-Ela"
  },
  {
    "code": "LK-33-004",
    "name": "Hambantota"
  },
  {
    "code": "LK-23-002",
    "name": "Hanguranketha"
  },
  {
    "code": "LK-11-003",
    "name": "Hanwella"
  },
  {
    "code": "LK-81-005",
    "name": "Haputale"
  },
  {
    "code": "LK-21-005",
    "name": "Harispattuwa"
  },
  {
    "code": "LK-21-006",
    "name": "Hatharaliyadda"
  },
  {
    "code": "LK-31-010",
    "name": "Hikkaduwa"
  },
  {
    "code": "LK-81-006",
    "name": "Hildummulla"
  },
  {
    "code": "LK-72-003",
    "name": "Hingurakgoda"
  },
  {
    "code": "LK-11-004",
    "name": "Homagama"
  },
  {
    "code": "LK-13-006",
    "name": "Horana"
  },
  {
    "code": "LK-71-003",
    "name": "Horowpothana"
  },
  {
    "code": "LK-61-009",
    "name": "Ibbagamuwa"
  },
  {
    "code": "LK-31-011",
    "name": "Imaduwa"
  },
  {
    "code": "LK-91-007",
    "name": "Imbulpe"
  },
  {
    "code": "LK-13-007",
    "name": "Ingiriya"
  },
  {
    "code": "LK-71-004",
    "name": "Ipalogama"
  },
  {
    "code": "LK-41-002",
    "name": "Island South (Velanai)"
  },
  {
    "code": "LK-41-003",
    "name": "Islands North (Kayts)"
  },
  {
    "code": "LK-12-006",
    "name": "Ja-Ela"
  },
  {
    "code": "LK-41-004",
    "name": "Jaffna"
  },
  {
    "code": "LK-21-007",
    "name": "K.F.G. & G. Korale"
  },
  {
    "code": "LK-11-005",
    "name": "Kaduwela"
  },
  {
    "code": "LK-71-005",
    "name": "Kahatagasdigiliya"
  },
  {
    "code": "LK-91-008",
    "name": "Kahawatta"
  },
  {
    "code": "LK-91-009",
    "name": "Kalawana"
  },
  {
    "code": "LK-52-008",
    "name": "Kalmunai"
  },
  {
    "code": "LK-62-005",
    "name": "Kalpitiya"
  },
  {
    "code": "LK-13-008",
    "name": "Kalutara"
  },
  {
    "code": "LK-32-006",
    "name": "Kamburupitiya"
  },
  {
    "code": "LK-81-007",
    "name": "Kandaketiya"
  },
  {
    "code": "LK-42-001",
    "name": "Kandavalai"
  },
  {
    "code": "LK-53-002",
    "name": "Kanthalai"
  },
  {
    "code": "LK-42-002",
    "name": "Karachchi"
  },
  {
    "code": "LK-31-012",
    "name": "Karandeniya"
  },
  {
    "code": "LK-52-009",
    "name": "Karativu"
  },
  {
    "code": "LK-62-006",
    "name": "Karuwalagaswewa"
  },
  {
    "code": "LK-12-007",
    "name": "Katana"
  },
  {
    "code": "LK-82-004",
    "name": "Katharagama"
  },
  {
    "code": "LK-51-003",
    "name": "Kattankudy"
  },
  {
    "code": "LK-61-010",
    "name": "Katupotha"
  },
  {
    "code": "LK-33-005",
    "name": "Katuwana"
  },
  {
    "code": "LK-71-006",
    "name": "Kebithigollewa"
  },
  {
    "code": "LK-92-006",
    "name": "Kegalle"
  },
  {
    "code": "LK-71-007",
    "name": "Kekirawa"
  },
  {
    "code": "LK-12-008",
    "name": "Kelaniya"
  },
  {
    "code": "LK-11-006",
    "name": "Kesbewa"
  },
  {
    "code": "LK-53-003",
    "name": "Kinniya"
  },
  {
    "code": "LK-91-010",
    "name": "Kiriella"
  },
  {
    "code": "LK-32-007",
    "name": "Kirinda-Puhulwella"
  },
  {
    "code": "LK-61-011",
    "name": "Kobeigane"
  },
  {
    "code": "LK-91-011",
    "name": "Kolonna"
  },
  {
    "code": "LK-11-007",
    "name": "Kolonnawa"
  },
  {
    "code": "LK-51-004",
    "name": "Koralai Pattu (Valachchenai)"
  },
  {
    "code": "LK-51-005",
    "name": "Koralai Pattu North"
  },
  {
    "code": "LK-51-006",
    "name": "Koralai Pattu West (Oddamavadi)"
  },
  {
    "code": "LK-32-008",
    "name": "Kotapola"
  },
  {
    "code": "LK-61-012",
    "name": "Kotavehera"
  },
  {
    "code": "LK-23-003",
    "name": "Kothmale"
  },
  {
    "code": "LK-53-004",
    "name": "Kuchchaveli"
  },
  {
    "code": "LK-61-013",
    "name": "Kuliyapitiya East"
  },
  {
    "code": "LK-61-014",
    "name": "Kuliyapitiya West"
  },
  {
    "code": "LK-21-008",
    "name": "Kundasale"
  },
  {
    "code": "LK-61-015",
    "name": "Kurunegala"
  },
  {
    "code": "LK-91-012",
    "name": "Kuruvita"
  },
  {
    "code": "LK-22-004",
    "name": "Laggala-Pallegama"
  },
  {
    "code": "LK-52-010",
    "name": "Lahugala"
  },
  {
    "code": "LK-72-004",
    "name": "Lankapura"
  },
  {
    "code": "LK-81-008",
    "name": "Lunugala"
  },
  {
    "code": "LK-33-006",
    "name": "Lunugamvehera"
  },
  {
    "code": "LK-62-007",
    "name": "Madampe"
  },
  {
    "code": "LK-43-001",
    "name": "Madhu"
  },
  {
    "code": "LK-82-005",
    "name": "Madulla"
  },
  {
    "code": "LK-13-009",
    "name": "Madurawala"
  },
  {
    "code": "LK-71-008",
    "name": "Maha Vilachchiya"
  },
  {
    "code": "LK-62-008",
    "name": "Mahakumbukkadawala"
  },
  {
    "code": "LK-52-011",
    "name": "Mahaoya"
  },
  {
    "code": "LK-12-009",
    "name": "Mahara"
  },
  {
    "code": "LK-11-008",
    "name": "Maharagama"
  },
  {
    "code": "LK-61-016",
    "name": "Mahawa"
  },
  {
    "code": "LK-62-009",
    "name": "Mahawewa"
  },
  {
    "code": "LK-81-009",
    "name": "Mahiyanganaya"
  },
  {
    "code": "LK-32-009",
    "name": "Malimbada"
  },
  {
    "code": "LK-61-017",
    "name": "Mallawapitiya"
  },
  {
    "code": "LK-51-007",
    "name": "Manmunai North"
  },
  {
    "code": "LK-51-008",
    "name": "Manmunai Pattu (Araipattai)"
  },
  {
    "code": "LK-51-009",
    "name": "Manmunai South and Eruvilpattu"
  },
  {
    "code": "LK-51-010",
    "name": "Manmunai South-West"
  },
  {
    "code": "LK-51-011",
    "name": "Manmunai West"
  },
  {
    "code": "LK-43-002",
    "name": "Mannar Town"
  },
  {
    "code": "LK-45-001",
    "name": "Manthai East"
  },
  {
    "code": "LK-43-003",
    "name": "Manthai West"
  },
  {
    "code": "LK-45-002",
    "name": "Maritimepattu"
  },
  {
    "code": "LK-61-018",
    "name": "Maspotha"
  },
  {
    "code": "LK-22-005",
    "name": "Matale"
  },
  {
    "code": "LK-32-010",
    "name": "Matara Four Gravets"
  },
  {
    "code": "LK-13-010",
    "name": "Mathugama"
  },
  {
    "code": "LK-92-007",
    "name": "Mawanella"
  },
  {
    "code": "LK-61-019",
    "name": "Mawathagama"
  },
  {
    "code": "LK-21-009",
    "name": "Medadumbara"
  },
  {
    "code": "LK-82-006",
    "name": "Medagama"
  },
  {
    "code": "LK-71-009",
    "name": "Medawachchiya"
  },
  {
    "code": "LK-72-005",
    "name": "Medirigiriya"
  },
  {
    "code": "LK-81-010",
    "name": "Meegahakivula"
  },
  {
    "code": "LK-71-010",
    "name": "Mihinthale"
  },
  {
    "code": "LK-13-011",
    "name": "Millaniya"
  },
  {
    "code": "LK-21-010",
    "name": "Minipe"
  },
  {
    "code": "LK-12-010",
    "name": "Minuwangoda"
  },
  {
    "code": "LK-12-011",
    "name": "Mirigama"
  },
  {
    "code": "LK-82-007",
    "name": "Moneragala"
  },
  {
    "code": "LK-11-009",
    "name": "Moratuwa"
  },
  {
    "code": "LK-53-005",
    "name": "Morawewa"
  },
  {
    "code": "LK-32-011",
    "name": "Mulatiyana"
  },
  {
    "code": "LK-62-010",
    "name": "Mundalama"
  },
  {
    "code": "LK-43-004",
    "name": "Musali"
  },
  {
    "code": "LK-53-006",
    "name": "Muttur"
  },
  {
    "code": "LK-71-011",
    "name": "N. Palatha Central"
  },
  {
    "code": "LK-71-012",
    "name": "N. Palatha East"
  },
  {
    "code": "LK-71-013",
    "name": "Nachchaduwa"
  },
  {
    "code": "LK-31-013",
    "name": "Nagoda"
  },
  {
    "code": "LK-41-005",
    "name": "Nallur"
  },
  {
    "code": "LK-43-005",
    "name": "Nanaddan"
  },
  {
    "code": "LK-61-020",
    "name": "Narammala"
  },
  {
    "code": "LK-62-011",
    "name": "Nattandiya"
  },
  {
    "code": "LK-22-006",
    "name": "Naula"
  },
  {
    "code": "LK-52-012",
    "name": "Navithanveli"
  },
  {
    "code": "LK-62-012",
    "name": "Nawagattegama"
  },
  {
    "code": "LK-12-012",
    "name": "Negombo"
  },
  {
    "code": "LK-31-014",
    "name": "Neluwa"
  },
  {
    "code": "LK-61-021",
    "name": "Nikaweratiya"
  },
  {
    "code": "LK-52-013",
    "name": "Ninthavur"
  },
  {
    "code": "LK-91-013",
    "name": "Nivithigala"
  },
  {
    "code": "LK-31-015",
    "name": "Niyagama"
  },
  {
    "code": "LK-71-014",
    "name": "Nochchiyagama"
  },
  {
    "code": "LK-23-004",
    "name": "Nuwara Eliya"
  },
  {
    "code": "LK-45-003",
    "name": "Oddusuddan"
  },
  {
    "code": "LK-33-007",
    "name": "Okewela"
  },
  {
    "code": "LK-91-014",
    "name": "Opanayaka"
  },
  {
    "code": "LK-42-003",
    "name": "Pachchilaipalli"
  },
  {
    "code": "LK-53-007",
    "name": "Padavi Sri Pura"
  },
  {
    "code": "LK-71-015",
    "name": "Padaviya"
  },
  {
    "code": "LK-52-014",
    "name": "Padiyathalawa"
  },
  {
    "code": "LK-11-010",
    "name": "Padukka"
  },
  {
    "code": "LK-71-016",
    "name": "Palagala"
  },
  {
    "code": "LK-13-012",
    "name": "Palindanuwara"
  },
  {
    "code": "LK-62-013",
    "name": "Pallama"
  },
  {
    "code": "LK-22-007",
    "name": "Pallepola"
  },
  {
    "code": "LK-71-017",
    "name": "Palugaswewa"
  },
  {
    "code": "LK-13-013",
    "name": "Panadura"
  },
  {
    "code": "LK-61-022",
    "name": "Panduwasnuwara"
  },
  {
    "code": "LK-61-023",
    "name": "Pannala"
  },
  {
    "code": "LK-21-011",
    "name": "Panvila"
  },
  {
    "code": "LK-21-012",
    "name": "Pasbage Korale"
  },
  {
    "code": "LK-32-012",
    "name": "Pasgoda"
  },
  {
    "code": "LK-81-011",
    "name": "Passara"
  },
  {
    "code": "LK-21-013",
    "name": "Pathadumbara"
  },
  {
    "code": "LK-21-014",
    "name": "Pathahewaheta"
  },
  {
    "code": "LK-91-015",
    "name": "Pelmadulla"
  },
  {
    "code": "LK-32-013",
    "name": "Pitabeddara"
  },
  {
    "code": "LK-61-024",
    "name": "Polgahawela"
  },
  {
    "code": "LK-61-025",
    "name": "Polpithigama"
  },
  {
    "code": "LK-21-015",
    "name": "Poojapitiya"
  },
  {
    "code": "LK-42-004",
    "name": "Poonakary"
  },
  {
    "code": "LK-51-012",
    "name": "Porativu Pattu"
  },
  {
    "code": "LK-52-015",
    "name": "Pothuvil"
  },
  {
    "code": "LK-45-004",
    "name": "Puthukudiyiruppu"
  },
  {
    "code": "LK-62-014",
    "name": "Puttalam"
  },
  {
    "code": "LK-71-018",
    "name": "Rajanganaya"
  },
  {
    "code": "LK-71-019",
    "name": "Rambewa"
  },
  {
    "code": "LK-92-008",
    "name": "Rambukkana"
  },
  {
    "code": "LK-61-026",
    "name": "Rasnayakapura"
  },
  {
    "code": "LK-91-016",
    "name": "Ratnapura"
  },
  {
    "code": "LK-22-008",
    "name": "Rattota"
  },
  {
    "code": "LK-81-012",
    "name": "Rideemaliyadda"
  },
  {
    "code": "LK-61-027",
    "name": "Ridigama"
  },
  {
    "code": "LK-92-009",
    "name": "Ruwanwella"
  },
  {
    "code": "LK-52-016",
    "name": "Sainthamarathu"
  },
  {
    "code": "LK-52-017",
    "name": "Sammanthurai"
  },
  {
    "code": "LK-53-008",
    "name": "Seruvila"
  },
  {
    "code": "LK-82-008",
    "name": "Sevanagala"
  },
  {
    "code": "LK-82-009",
    "name": "Siyambalanduwa"
  },
  {
    "code": "LK-33-008",
    "name": "Sooriyawewa"
  },
  {
    "code": "LK-81-013",
    "name": "Soranathota"
  },
  {
    "code": "LK-11-011",
    "name": "Sri Jayawardanapura Kotte"
  },
  {
    "code": "LK-33-009",
    "name": "Tangalle"
  },
  {
    "code": "LK-71-020",
    "name": "Thalawa"
  },
  {
    "code": "LK-72-006",
    "name": "Thamankaduwa"
  },
  {
    "code": "LK-71-021",
    "name": "Thambuttegama"
  },
  {
    "code": "LK-53-009",
    "name": "Thampalakamam"
  },
  {
    "code": "LK-82-010",
    "name": "Thanamalvila"
  },
  {
    "code": "LK-31-016",
    "name": "Thawalama"
  },
  {
    "code": "LK-41-006",
    "name": "Thenmaradchy (Chavakachcheri)"
  },
  {
    "code": "LK-32-014",
    "name": "Thihagoda"
  },
  {
    "code": "LK-11-012",
    "name": "Thimbirigasyaya"
  },
  {
    "code": "LK-71-022",
    "name": "Thirappane"
  },
  {
    "code": "LK-52-018",
    "name": "Thirukkovil"
  },
  {
    "code": "LK-33-010",
    "name": "Thissamaharama"
  },
  {
    "code": "LK-21-016",
    "name": "Thumpane"
  },
  {
    "code": "LK-45-005",
    "name": "Thunukkai"
  },
  {
    "code": "LK-53-010",
    "name": "Trincomalee Town and Gravets"
  },
  {
    "code": "LK-21-017",
    "name": "Udadumbara"
  },
  {
    "code": "LK-21-018",
    "name": "Udapalatha"
  },
  {
    "code": "LK-61-028",
    "name": "Udubaddawa"
  },
  {
    "code": "LK-21-019",
    "name": "Udunuwara"
  },
  {
    "code": "LK-52-019",
    "name": "Uhana"
  },
  {
    "code": "LK-22-009",
    "name": "Ukuwela"
  },
  {
    "code": "LK-81-014",
    "name": "Uva Paranagama"
  },
  {
    "code": "LK-41-007",
    "name": "Vadamaradchi South-West"
  },
  {
    "code": "LK-41-008",
    "name": "Vadamaradchy East"
  },
  {
    "code": "LK-41-009",
    "name": "Vadamaradchy North"
  },
  {
    "code": "LK-41-010",
    "name": "Valikamam East"
  },
  {
    "code": "LK-41-011",
    "name": "Valikamam North"
  },
  {
    "code": "LK-41-012",
    "name": "Valikamam South"
  },
  {
    "code": "LK-41-013",
    "name": "Valikamam South-West"
  },
  {
    "code": "LK-41-014",
    "name": "Valikamam West"
  },
  {
    "code": "LK-44-001",
    "name": "Vavuniya"
  },
  {
    "code": "LK-44-002",
    "name": "Vavuniya North"
  },
  {
    "code": "LK-44-003",
    "name": "Vavuniya South"
  },
  {
    "code": "LK-44-004",
    "name": "Vengalacheddiculam"
  },
  {
    "code": "LK-53-011",
    "name": "Verugal"
  },
  {
    "code": "LK-13-014",
    "name": "Walallawita"
  },
  {
    "code": "LK-23-005",
    "name": "Walapane"
  },
  {
    "code": "LK-62-015",
    "name": "Wanathavilluwa"
  },
  {
    "code": "LK-92-010",
    "name": "Warakapola"
  },
  {
    "code": "LK-61-029",
    "name": "Wariyapola"
  },
  {
    "code": "LK-12-013",
    "name": "Wattala"
  },
  {
    "code": "LK-33-011",
    "name": "Weeraketiya"
  },
  {
    "code": "LK-61-030",
    "name": "Weerambugedara"
  },
  {
    "code": "LK-32-015",
    "name": "Weligama"
  },
  {
    "code": "LK-91-017",
    "name": "Weligepola"
  },
  {
    "code": "LK-72-007",
    "name": "Welikanda"
  },
  {
    "code": "LK-81-015",
    "name": "Welimada"
  },
  {
    "code": "LK-32-016",
    "name": "Welipitiya"
  },
  {
    "code": "LK-31-017",
    "name": "Welivitiya-Divithura"
  },
  {
    "code": "LK-82-011",
    "name": "Wellawaya"
  },
  {
    "code": "LK-62-016",
    "name": "Wennappuwa"
  },
  {
    "code": "LK-22-010",
    "name": "Wilgamuwa"
  },
  {
    "code": "LK-31-018",
    "name": "Yakkalamulla"
  },
  {
    "code": "LK-22-011",
    "name": "Yatawatta"
  },
  {
    "code": "LK-21-020",
    "name": "Yatinuwara"
  },
  {
    "code": "LK-92-011",
    "name": "Yatiyanthota"
  }
]